const TOKEN_KEY = 'jwt_token'

export const tokenStore = {
  get: () => localStorage.getItem(TOKEN_KEY),
  set: (t) => localStorage.setItem(TOKEN_KEY, t),
  clear: () => localStorage.removeItem(TOKEN_KEY)
}

export async function apiRequest(path, { method = 'GET', body, auth = true } = {}) {
  const headers = { 'Content-Type': 'application/json', Accept: 'application/json' }
  if (auth) {
    const token = tokenStore.get()
    if (token) headers.Authorization = `Bearer ${token}`
  }

  const res = await fetch(path, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined
  })

  const authHeader = res.headers.get('Authorization')
  if (authHeader?.startsWith('Bearer ')) {
    tokenStore.set(authHeader.slice(7))
  }

  const contentType = res.headers.get('content-type') || ''
  const data = contentType.includes('application/json') && res.status !== 204
    ? await res.json()
    : null

  if (!res.ok) {
    const err = new Error(data?.error || data?.errors?.join(', ') || `Request failed: ${res.status}`)
    err.status = res.status
    err.data = data
    throw err
  }

  return data
}

// Authenticated file download. Fetches the URL with the JWT header, reads
// the response as a blob, and triggers a browser download. Use this when
// the response is a non-JSON binary (CSV, PDF, etc.) and a plain <a href>
// won't work because the endpoint requires Authorization.
export async function downloadFile(path, { filename } = {}) {
  const headers = {}
  const token = tokenStore.get()
  if (token) headers.Authorization = `Bearer ${token}`

  const res = await fetch(path, { headers })
  if (!res.ok) {
    let message = `Download failed: ${res.status}`
    try {
      const data = await res.json()
      message = data?.error || data?.errors?.join(', ') || message
    } catch (_) { /* response wasn't JSON */ }
    const err = new Error(message)
    err.status = res.status
    throw err
  }

  const blob = await res.blob()
  const disposition = res.headers.get('Content-Disposition') || ''
  const matched = disposition.match(/filename="?([^"]+)"?/i)
  const resolvedName = filename || matched?.[1] || 'download'

  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = resolvedName
  document.body.appendChild(link)
  link.click()
  link.remove()
  URL.revokeObjectURL(url)
}
